import { Organization } from '../models/organization';
import { CUSTOMIZATION_ENABLED_TAG } from '../constants/tags';

export const isProOrg = (org: Organization): boolean => (
  org?.referrer_org_id === parseInt(process.env.ORGANIZATION_SIGNUP_REFERRER_ID || '', 10) ||
  org?.referrer_org_id === parseInt(process.env.ORGANIZATION_SIGNUP_REFERRER_ID_S1 || '', 10) ||
  org?.referrer_org_id === parseInt(process.env.ORGANIZATION_SIGNUP_REFERRER_ID_S0_REST || '', 10)
);

export const hasCustomizationEnabledTag = (org: Organization): boolean => (
  org?.tags?.indexOf(CUSTOMIZATION_ENABLED_TAG) > -1
);
